export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/certificate',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/basis/certificate',
      method: 'POST'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/certificate/{id}',
      method: 'PUT'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/certificate/{id}',
      method: 'DELETE'
    }]
  }
}